import { useContext } from "react";
import { DataContext } from "../../../store/data-context";
import styles from "./Section3.module.css";
const Section3 = () => {
  const { section3Data } =
    useContext(DataContext);

  return (
    <section
      className={styles["main-section__3"]}
    >
      <h2>Our Expert Attorneys</h2>
      <div
        className={
          styles["main-section__3__attorneys"]
        }
      >
        {section3Data.map((data) => {
          return (
            <div
              key={data.id}
              className={
                styles[
                  "main-section__3__attorney"
                ]
              }
            >
              <div
                id={
                  styles[
                    "main-section__3__attorney__image"
                  ]
                }
                style={{
                  backgroundImage: `url(${data.image})`,
                }}
              ></div>
              <h3>{data.name}</h3>
              <p>{data.about}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Section3;
